// import React, { useState ,useEffect} from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setShippingAddress, setBillingAddress, toggleUseSameAsShipping } from "../../store/addressSlice";
// import AddressPopup from "./AddressPopup";
// import Footer from "../Footer/footer";
// import Navbar from "../Navbar/navbar";
// import { useLocation } from "react-router-dom";
// import SavedAddressesPopup from "./savedAddressesPopup";

// const Checkout = () => {
//   const dispatch = useDispatch();

//   // Redux state
//   const { shippingAddress, billingAddress, useSameAsShipping } = useSelector((state) => state.address);

//   const [paymentMethod, setPaymentMethod] = useState("PREPAID");
//   const [showShippingPopup, setShowShippingPopup] = useState(false);
//   const [showBillingPopup, setShowBillingPopup] = useState(false);
//   const [billingAddressInput, setBillingAddressInput] = useState({
//     name: '',
//     address: '',
//     phone: '',
//   });
//   const [showSavedAddressesPopup, setShowSavedAddressesPopup] = useState(false);

//   const handleAddShippingAddress = (address) => {
//     dispatch(setShippingAddress(address));
//   };

//   const handleToggleAddBillingAddress = (address) => {
//     dispatch(setBillingAddress(address));
//   };

//   const handleToggleUseSameAsShipping = () => {
//     dispatch(toggleUseSameAsShipping());
//   };

//   const location = useLocation();
//   const { item, gst, totalPrice, selectedSize, selectedColor, quantity,cart } = location.state || {cart: []};
//   const fullAddress = shippingAddress
//     ? `${shippingAddress.addressLine1}, ${shippingAddress.addressLine2}, ${shippingAddress.city}, ${shippingAddress.state} - ${shippingAddress.postalCode}, ${shippingAddress.country}`
//     : '';
//     // const { cart, gst, totalPrice } = location.state || { cart: [] };

//     // Disable scrolling when any popup is open
//   useEffect(() => {
//     if (showShippingPopup || showBillingPopup || showSavedAddressesPopup) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }

//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [showShippingPopup, showBillingPopup, showSavedAddressesPopup]);

//   return (
//     <>
//       <Navbar />
//       <div className="w-full relative top-14 py-16 px-12 bg-tertiary overflow-x-hidden text-primary1 lg:px-24 xl:px-32">
//         {/* Top Section */}
//         <div className="flex justify-between items-center pb-4">
//           <button className="text-sm text-blue-600">Back</button>
//           <h1 className="text-4xl font-normal font-outfit text-center text-primary1">CHECKOUT</h1>
//           <div />
//         </div>
//         <hr className="border-secondary mb-4" />

//         <div className="mt-6 space-y-6 lg:grid lg:grid-cols-3 lg:gap-6 lg:space-y-0">

//           {/* Left Section */}
//           <div className="col-span-2 space-y-6">
//             {/* Shipping Address */}
//             <div>
//               <h2 className="text-2xl font-outfit font-light text-primary1">Shipping Address</h2>
//               {shippingAddress ? (
//                 <div className=" mt-4">
//                   <p className="font-bold">{shippingAddress.name}</p>
//                   <p>{shippingAddress.email}</p>
//                   <p>{shippingAddress.phone}</p>
//                   <p>{fullAddress}</p>
//                   <p
//                     className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded"
//                     onClick={() => setShowSavedAddressesPopup(true)}
//                   >
//                     Change Address
//                   </p>
//                 </div>
//               ) : (
//                 <div className="p-4 mt-4">
//                   <p className="font-bold">Ohoen</p> {/* Default name */}
//                   <p>defaultemail@example.com</p> {/* Default email */}
//                   <p>+91 123 456 7890</p> {/* Default phone */}
//                   <button
//                     className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded"
//                     onClick={() => setShowShippingPopup(true)}
//                   >
//                     Add Address
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Billing Address */}
//             <div>
//               <h2 className="text-2xl font-outfit font-light text-primary1">Billing Address</h2>
//               <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-4">
//                 <div className="lg:w-[50%]">
//                 <label className="flex items-center mb-2 sm:mb-0 border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal">
//                   <input
//                     type="radio"
//                     className="mr-2"
//                     checked={useSameAsShipping}
//                     onChange={handleToggleUseSameAsShipping}
//                   />
//                   Same as shipping address
//                 </label>
//                 </div>
//                <div className="lg:w-[50%]">
//                <label className="flex items-center border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal ">
//                   <input
//                     type="radio"
//                     className="mr-2"
//                     checked={!useSameAsShipping}
//                     onChange={handleToggleUseSameAsShipping}
//                   />
//                   Use a different billing address
//                 </label>
//                </div>

//               </div>

//               {useSameAsShipping ? (
//                 shippingAddress ? (
//                   <p className="mt-4 ">Billing Address is same as Shipping Address</p>
//                   // <div className="p-4 mt-4">
//                   //   <p className="font-bold">{shippingAddress.name}</p>
//                   //   <p>{fullAddress}</p>
//                   //   <p>{shippingAddress.phone}</p>
//                   // </div>
//                 ) : (
//                   <p className="mt-4 text-gray-500">No shipping address added yet.</p>
//                 )
//               ) : billingAddress ? (
//                 <div className="border p-4 rounded mt-4">
//                   <p className="font-bold">{billingAddress.name}</p>
//                   <p>{billingAddress.address}</p>
//                   <p>{billingAddress.phone}</p>
//                 </div>
//               ) : (
//                 <button
//                   className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded"
//                   onClick={() => setShowBillingPopup(true)}
//                 >
//                   Add Billing Address
//                 </button>
//               )}
//             </div>

//   {/* Payment Options */}
//   <div>
//     <h2 className="text-lg font-semibold">Payment Method</h2>
//     <div className="flex flex-col sm:flex-row sm:space-x-4 mt-4">
//       <div className="lg:w-[50%]">
//       <label className="flex items-center mb-2 sm:mb-0 border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal">
//         <input
//           type="radio"
//           className="mr-2 "
//           name="paymentMethod"
//           checked={paymentMethod === "PREPAID"}
//           onChange={() => setPaymentMethod("PREPAID")}
//         />
//         Pay Online
//       </label>
//       </div>

//       <div className="lg:w-[50%]">
//       <label className="flex items-center border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal">
//         <input
//           type="radio"
//           className="mr-2"
//           name="paymentMethod"
//           checked={paymentMethod === "COD"}
//           onChange={() => setPaymentMethod("COD")}
//         />
//         COD
//       </label>
//       </div>

//     </div>
//   </div>
// </div>
// <div className="hidden lg:block w-[1px] bg-secondary absolute left-2/3 top-[18%] bottom-0 lg:-mx-7 xl:-mx-11"></div>
//           {/* Right Section */}
//           <div className="space-y-4">
//   <h2 className="text-xl font-outfit font-light">Order Details</h2>
//   {cart.length > 0 ? (
//     cart.map((item, index) => (
//       <div key={index} className="lg:p-4">
//         <div className="flex items-center space-x-4">
//           <img
//             src={item.thumbnail}
//             alt={item.title}
//             className="w-28 h-28 md:w-32 md:h-32"
//           />
//           <div>
//             <p className="font-outfit font-light text-lg lg:text-xl whitespace-nowrap">
//               {item.title.toUpperCase()}
//             </p>
//             <p className="text-hcolor font-poppins font-extralight text-sm lg:text-base">
//               Size: {item.selectedSize || "Default"}
//             </p>
//             <p className="text-hcolor font-poppins font-extralight text-sm lg:text-base">
//               Color: {item.selectedColor || "Default"}
//             </p>
//             <p className="text-hcolor font-poppins font-extralight text-sm lg:text-base">
//               Quantity: {item.quantity}
//             </p>
//             <p className="text-hcolor font-poppins font-extralight text-sm lg:text-base">
//               Material: {item.material}
//             </p>
//           </div>
//           <p className="ml-auto font-semibold text-hcolor">
//             Rs.{item.discountedPrice.toFixed(2)}
//           </p>
//         </div>
//       </div>
//     ))
//   ) : (
//     <p>No items in cart.</p>
//   )}

// {/* Price Breakdown */}
// <div className="pt-4 space-y-2">
//   <div className="flex justify-between">
//     <p>Subtotal</p>
//     <p>Rs.{cart.reduce((acc, item) => acc + item.discountedPrice * item.quantity, 0).toFixed(2)}</p>
//   </div>
//   <div className="flex justify-between">
//     <p>GST (18%)</p>
//     <p>Rs.{gst ? gst.toFixed(2) : "0.00"}</p>
//   </div>
//   <hr className="border-secondary mb-4" />
//   <div className="flex justify-between font-semibold">
//     <p>Total</p>
//     <p>Rs.{totalPrice ? totalPrice.toFixed(2) : "0.00"}</p>
//   </div>
// </div>

//   {/* Confirm Button */}
//   <button className="w-full px-4 py-2 bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor hover:border mt-6">
//     Place Order
//   </button>
// </div>;
//         </div>
//       </div>

// {/* Popups */}
// {showShippingPopup && (
//   <AddressPopup
//     title="Add Shipping Address"
//     onClose={() => setShowShippingPopup(false)}
//     onSave={handleAddShippingAddress}
//   />
// )}
// {showBillingPopup && (
//   <AddressPopup
//     title="Add Billing Address"
//     onClose={() => setShowBillingPopup(false)}
//     onSave={handleToggleAddBillingAddress}
//   />
// )}
// {showSavedAddressesPopup && (
//   <SavedAddressesPopup
//     onClose={() => setShowSavedAddressesPopup(false)}
//     onSelectAddress={handleAddShippingAddress}
//   />
// )}
//        <div className="relative">
//   <Footer />
//   <div className="hidden lg:block absolute left-2/3 top-0 h-[35%] border-l-[1px] border-secondary -mx-11"></div>
// </div>
//     </>
//   );
// };

// export default Checkout;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setShippingAddress,
  setBillingAddress,
  toggleUseSameAsShipping,
  removeAllAddresses,fetchAddresses
} from "../../store/addressSlice";
import AddressPopup from "./AddressPopup";
import Footer from "../Footer/footer";
import Navbar from "../Navbar/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import SavedAddressesPopup from "./savedAddressesPopup";
import icons from "../../icons.config";
import FooterDoodles from "../Footer/footerDoodles";
import { applyCouponAPI } from "../../Providers/couponsProvider";

const Checkout = ({ fromCart, productId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  
    const [address, setAddress] = useState(null); // ✅ Define setAddress
    
  // Redux state
  const { shippingAddress, billingAddress, useSameAsShipping } = useSelector(
    (state) => state.address
  );

  const [paymentMethod, setPaymentMethod] = useState("PREPAID");
  const [showShippingPopup, setShowShippingPopup] = useState(false);
  const [showBillingPopup, setShowBillingPopup] = useState(false);
  const [showSavedAddressesPopup, setShowSavedAddressesPopup] = useState(false);

  const handleAddShippingAddress = (address) => {
    dispatch(setShippingAddress(address));
  };

  const handleToggleAddBillingAddress = (address) => {
    dispatch(setBillingAddress(address));
  };

  const handleToggleUseSameAsShipping = () => {
    dispatch(toggleUseSameAsShipping());
  };

  const location = useLocation();
  const {
    item,
    gst,
    totalPrice,
    selectedSize,
    selectedColor,
    quantity,
    cart = [],
  } = location.state || {};

  // **Filter out out-of-stock items**
  const filteredCart = cart.filter((cartItem) => cartItem.inStock);

  // Also check if single `item` is in stock when not coming from the cart
  const validItem = item && item.inStock ? item : null;

  // Calculate subtotal (only for in-stock items)
  let subtotal = 0;

  if (filteredCart.length > 0) {
    subtotal = filteredCart.reduce(
      (acc, cartItem) => acc + cartItem.discountedPrice * cartItem.quantity,
      0
    );
  } else if (validItem) {
    subtotal = validItem.discountedPrice * quantity;
  }

  // Apply GST to the subtotal (18%)
  const finalGst = subtotal * 0.18;

  // Final total price including GST
  const finalTotalPrice = subtotal + finalGst;

  const fullAddress = shippingAddress
    ? `${shippingAddress.house_number},${shippingAddress.main_street},${shippingAddress.landmark}, ${shippingAddress.city}, ${shippingAddress.state} - ${shippingAddress.postal_code}, ${shippingAddress.country}`
    : "";

  // Handle scrolling when popups are open
  useEffect(() => {
    if (showShippingPopup || showBillingPopup || showSavedAddressesPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showShippingPopup, showBillingPopup, showSavedAddressesPopup]);
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);

  const handleApplyCoupon = async () => {
    if (!couponCode) {
      alert("Please enter a coupon code.");
      return;
    }
  
    try {
      const response = await applyCouponAPI(couponCode);
  
      if (response && response.discountAmount) {
        setCouponDiscount(response.discountAmount);
        alert(`Coupon Applied! You got Rs.${response.discountAmount} off.`);
      } else {
        setCouponDiscount(0);
        alert(response.message || "Invalid Coupon Code");
      }
    } catch (error) {
      setCouponDiscount(0);
      alert(error || "Failed to apply coupon. Please try again.");
    }
  };
  

  const handleBackClick = () => {
    if (location.state?.fromCheckout) {
      // If the user came from checkout, go back to the previous page
      navigate(-1);
    } else if (location.state?.fromProduct) {
      // If the user came from a product page, navigate back to it
      navigate(location.state.fromProduct);
    } else if (fromCart) {
      // If the user came from the cart, go to home or cart page
      navigate("/");
    } else {
      // Fallback: Go back to the last visited page
      navigate(-1);
    }
  };
  const handleRemoveAllAddresses = () => {
    dispatch(removeAllAddresses());
  };
  // Default user info (hardcoded values)
  const defaultUserInfo = {
    name: "Default Name",
    email: "default@example.com",
    phone: "123-456-7890",
  };

  return (
    <>
      <section className="overflow-y-hidden">
        <Navbar />
        <div className="w-full py-24 md:py-44 xl:py-32 relative top-12  px-12 bg-tertiary overflow-hidden text-primary1 lg:px-24 xl:px-32">
          <div className="absolute -top-8 -right-1 lg:-top-14 lg:-right-20  z-10">
            <img
              src={icons.trendCircles}
              alt="Doodle Left"
              className="w-44 md:w-60 lg:w-4/5"
            />
          </div>
          {/* Top Section */}
          <div className="flex justify-between items-center pb-4">
            <button onClick={handleBackClick} className="text-sm text-blue-600">
              <img src={icons.back} alt="back button" />
            </button>

            <h1 className="text-4xl font-normal font-outfit text-center text-primary1">
              CHECKOUT
            </h1>
            <div />
          </div>
          <hr className="border-secondary border-[1px] mb-4" />

          <div className="mt-6 space-y-6 lg:grid lg:grid-cols-10 lg:gap-6 lg:space-y-0">
            {/* Left Section */}
            <div className="col-span-6 space-y-6">
              {/* Shipping Address */}
              <div>
                <h2 className="text-2xl font-outfit font-light text-primary1">
                  Shipping Details
                </h2>
                
                {!shippingAddress ||
                Object.keys(shippingAddress).length === 0 ? (
                  <div>
                    {/* Default information when no address exists */}
                    <p className="text-primary1 font-poppins font-light text-xl">
                      {defaultUserInfo.name}
                    </p>
                    <div className="flex items-center space-x-2">
                      <img
                        src={icons.eMail}
                        alt="Email Icon"
                        className="w-5 h-5"
                      />
                      <p className="text-hcolor font-poppins font-light text-base">
                        {defaultUserInfo.email}
                      </p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <img
                        src={icons.phone}
                        alt="Phone Icon"
                        className="w-5 h-5"
                      />
                      <p className="text-hcolor font-poppins font-light text-base">
                        {defaultUserInfo.phone}
                      </p>
                    </div>

                    {/* Add Address button */}
                    <button
                      className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded"
                      onClick={() => setShowShippingPopup(true)}
                    >
                      Add Address
                    </button>
                  </div>
                ) : (
                  <div className="mt-4 lg:flex lg:justify-between lg:items-end">
                    <div>
                      <p className="text-primary1 font-poppins font-light text-xl">
                        {shippingAddress.first_name} {shippingAddress.last_name}
                      </p>
                      <div className="flex items-center space-x-2">
                        <img
                          src={icons.eMail}
                          alt="Email Icon"
                          className="w-5 h-5"
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {shippingAddress.email_id}
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <img
                          src={icons.phone}
                          alt="Phone Icon"
                          className="w-5 h-5"
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {shippingAddress.mobile_number}
                        </p>
                      </div>
                      <div className="flex items-start space-x-2">
                        <img
                          src={icons.address}
                          alt="Location Icon"
                          className="w-5 h-5 "
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {fullAddress}{" "}
                          {/* Use the derived fullAddress variable here */}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <p
                        className="px-4 py-2 text-primary1 underline text-base cursor-pointer"
                        onClick={() => setShowSavedAddressesPopup(true)}
                      >
                        Change Address
                      </p>
                      <button
                        className="px-4 py-2 bg-red-600 text-white rounded"
                        onClick={handleRemoveAllAddresses}
                      >
                        Remove Address
                      </button>
                    </div>
                  </div>
                )}
              </div>

              
              <div>
                <h2 className="text-2xl font-outfit font-light text-primary1">
                  Billing Address
                </h2>

                {/* Radio buttons for selecting same/different billing address */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-4 xl:pr-3">
                  <div className="md:w-[50%]">
                    <label className="flex items-center border-2 border-secondary rounded-md mb-2 py-2 px-3 font-poppins font-normal">
                      <input
                        type="radio"
                        className="mr-2"
                        checked={useSameAsShipping}
                        onChange={handleToggleUseSameAsShipping}
                      />
                      Same as shipping address
                    </label>
                  </div>
                  <div className="md:w-[50%]">
                    <label className="flex items-center border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal md:-mt-2">
                      <input
                        type="radio"
                        className="mr-2"
                        checked={!useSameAsShipping}
                        onChange={handleToggleUseSameAsShipping}
                      />
                      Use a different billing address
                    </label>
                  </div>
                </div>

                {/* Display Address */}
                {useSameAsShipping ? (
                  <p className="mt-4">
                    Billing Address is same as Shipping Address
                  </p>
                ) : billingAddress ? (
                  <div className="mt-4">
                    <div>
                      <p className="text-primary1 font-poppins font-light text-xl">
                        {billingAddress.first_name} {billingAddress.last_name}
                      </p>

                      <div className="flex items-center space-x-2">
                        <img
                          src={icons.eMail}
                          alt="Email Icon"
                          className="w-5 h-5"
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {billingAddress.email_id}
                        </p>
                      </div>

                      <div className="flex items-center space-x-2">
                        <img
                          src={icons.phone}
                          alt="Phone Icon"
                          className="w-5 h-5"
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {billingAddress.mobile_number}
                        </p>
                      </div>

                      <div className="flex items-start space-x-2">
                        <img
                          src={icons.address}
                          alt="Location Icon"
                          className="w-5 h-5"
                        />
                        <p className="text-hcolor font-poppins font-light text-base">
                          {billingAddress.house_number}, {billingAddress.main_street}, {billingAddress.landmark},{" "}
                          {billingAddress.city}, {billingAddress.state} {"-"}
                          {billingAddress.postal_code}, {billingAddress.country}
                        </p>
                      </div>

                      {/* "Change Billing Address" Button */}
                      <button
                        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                        onClick={() => setShowBillingPopup(true)}
                      >
                        Change Billing Address
                      </button>
                    </div>
                  </div>
                ) : (
                  <button
                    className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded"
                    onClick={() => setShowBillingPopup(true)}
                  >
                    Add Billing Address
                  </button>
                )}
              </div>

              {/* Payment Options */}
              <div>
                <h2 className="text-2xl font-light font-outfit">
                  Payment Option(2)
                </h2>
                <div className="flex flex-col sm:flex-row sm:space-x-4 mt-4 xl:pr-3">
                  <div className="md:w-[50%]">
                    <label className="flex items-center mb-2 sm:mb-0 border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal">
                      <input
                        type="radio"
                        className="mr-2 "
                        name="paymentMethod"
                        checked={paymentMethod === "PREPAID"}
                        onChange={() => setPaymentMethod("PREPAID")}
                      />
                      Pay Online
                    </label>
                  </div>

                  <div className="md:w-[50%]">
                    <label className="flex items-center border-2 border-secondary rounded-md py-2 px-3 font-poppins font-normal">
                      <input
                        type="radio"
                        className="mr-2"
                        name="paymentMethod"
                        checked={paymentMethod === "COD"}
                        onChange={() => setPaymentMethod("COD")}
                      />
                      COD
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="hidden lg:block w-[2px] bg-secondary absolute left-[58%] lg:top-[23%] xl:top-[24%] bottom-0 "></div> */}
            <div
              className={`hidden lg:block w-[2px] bg-secondary absolute left-[58%] bottom-0 transition-all duration-300 ${
                useSameAsShipping
                  ? "lg:top-[23%] xl:top-[23%] 2xl:top-[24%]"
                  : "lg:top-[20%] xl:top-[21%] 2xl:top-[21%]"
              }`}
            ></div>

            {/* Right Section: Order Details */}
            
            <div className="space-y-4 lg:col-span-4 ">
              <h2 className="text-xl font-outfit font-light">Order Details</h2>
              <div className="max-h-28 overflow-y-auto">
                {filteredCart.length > 0 ? (
                  filteredCart.map((item, index) => (
                    <div
                      key={index}
                      className="lg:py-4 flex items-center space-x-4"
                    >
                      <img
                        src={item.thumbnail}
                        alt={item.title}
                        className="w-28 h-28 md:w-16 md:h-24"
                      />
                      <div className="flex-1">
                        <p className="font-outfit font-light text-lg lg:text-xl">
                          {item.title.toUpperCase()}
                        </p>
                        <p className="text-hcolor">
                          Size: {item.selectedSize || "Default"}
                        </p>
                        <p className="text-hcolor">
                          Color: {item.selectedColor || "Default"}
                        </p>
                        <p className="text-hcolor">Quantity: {item.quantity}</p>
                      </div>
                      <p className="ml-auto font-normal text-hcolor text-right">
                        Rs.{item.discountedPrice.toFixed(2)}
                      </p>
                    </div>
                  ))
                ) : validItem ? (
                  <div className="space-x-4 flex items-center">
                    <img
                      src={validItem.thumbnail}
                      alt={validItem.title}
                      className="w-28 h-28 md:w-16 md:h-24"
                    />
                    <div className="flex-1">
                      <p className="font-outfit font-light text-lg lg:text-xl">
                        {validItem.title.toUpperCase()}
                      </p>
                      <p className="text-hcolor">Size: {selectedSize}</p>
                      <p className="text-hcolor">Color: {selectedColor}</p>
                      <p className="text-hcolor">Quantity: {quantity}</p>
                    </div>
                    <p className="ml-auto font-normal text-hcolor text-right">
                      Rs.{subtotal.toFixed(2)}
                    </p>
                  </div>
                ) : (
                  <p className="text-red-500 text-center">
                    No in-stock items available for checkout.
                  </p>
                )}
              </div>

              {/* Horizontal Line */}
              <hr className="border-secondary my-2" />

              {/* Coupon Code Input */}
              {/* <div className="w-full relative ">
                <input
                  type="text"
                  id="coupon"
                  placeholder="Enter Coupon Code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  className="w-full p-2 pt-2 border placeholder:font-poppins placeholder:font-normal placeholder:text-sm bg-tertiary border-primary1 rounded-lg focus:outline-none bg-transparent  peer focus:text-hcolor focus:font-normal focus:font-outfit focus:border-2"
                  required
                />
                <label
                  htmlFor="coupon"
                  className="absolute left-3 px-2 bg-tertiary text-primary1 bg-cream text-lg font-medium pointer-events-none transform -translate-y-4 scale-75 top-1 z-10 origin-[0] start-4"
                >
                  COUPON CODE
                </label>
                <button
                  onClick={handleApplyCoupon}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-primary1 font-medium underline"
                >
                  Apply
                </button>
              </div> */}
              {/* Coupon Code Input */}
<div className="w-full relative">
  <input
    type="text"
    id="coupon"
    placeholder="Enter Coupon Code"
    value={couponCode}
    onChange={(e) => setCouponCode(e.target.value)}
    className="w-full p-2 border rounded"
  />
  <button
    onClick={handleApplyCoupon}
    className="absolute right-2 top-1/2 transform -translate-y-1/2 px-4 py-2 bg-blue-600 text-white rounded"
  >
    Apply
  </button>
</div>

{/* Show discount if applied */}
{couponDiscount > 0 && (
  <p className="text-green-600 mt-2">
    Coupon applied! You saved Rs.{couponDiscount}.
  </p>
)}

              {/* Horizontal Line */}
              <hr className="border-secondary my-2" />

              {/* Price Breakdown */}
              <div className="space-y-2 ">
                <p className="text-base font-poppins text-hcolor flex font-light">
                  Subtotal:{" "}
                  <span className="ml-auto text-right">
                    Rs.{subtotal.toFixed(2)}
                  </span>
                </p>
                <p className="text-base font-poppins text-hcolor flex font-light">
                  GST (18%):{" "}
                  <span className="ml-auto text-right">
                    Rs.{finalGst.toFixed(2)}
                  </span>
                </p>
                {/* <p className="text-lg font-poppins text-hcolor">Coupon Discount: <span className="ml-auto text-green-600">- Rs.{couponDiscount.toFixed(2)}</span></p> */}

                {couponDiscount > 0 && (
                  <p className="text-base font-poppins text-hcolor flex font-light">
                    Coupon Discount:{" "}
                    <span className="ml-auto">
                      - Rs.{couponDiscount.toFixed(2)}
                    </span>
                  </p>
                )}
              </div>

              {/* Horizontal Line */}
              <hr className="border-secondary my-2" />

              {/* Total */}
              <p className="text-xl font-normal text-primary1 flex justify-between">
                {/* <span>Total:</span> <span>Rs.{finalTotalPrice.toFixed(2)}</span> */}
                <span>Total</span>{" "}
                <span>
                  Rs.{(finalTotalPrice - couponDiscount).toFixed(2)} INR
                </span>
              </p>

              {/* Place Order Button */}
              <button className="mt-4 px-6 py-2 bg-hcolor hover:bg-tertiary  text-tertiary hover:text-hcolor hover:border font-normal text-lg w-full">
                PLACE ORDER
              </button>
            </div>
          </div>
        </div>

        {/* Popups */}
        {showShippingPopup && (
          <AddressPopup
            onClose={() => setShowShippingPopup(false)}
            shippingAddress={shippingAddress}
            billingAddress={billingAddress}
            isBilling={false} // This means it's for shipping
          />
        )}

        {showBillingPopup && (
          <AddressPopup
            onClose={() => setShowBillingPopup(false)}
            shippingAddress={shippingAddress}
            billingAddress={billingAddress}
            isBilling={true} // This means it's for billing
          />
        )}

        {showSavedAddressesPopup && (
          <SavedAddressesPopup
            onClose={() => setShowSavedAddressesPopup(false)}
            onSelectAddress={setAddress}  
          />
        )}
        <div className="relative">
          <FooterDoodles />
          <div className="hidden lg:block absolute left-[58%] top-0 h-full border-l-[3px] border-secondary "></div>
        </div>
        <Footer />
      </section>
    </>
  );
};
export default Checkout;
